import { decode } from "base-64";
import Constants from "expo-constants";
import * as Notifications from "expo-notifications";
import { jwtDecode } from "jwt-decode";
import { isWeb } from "../constants";

type SaveTokensProps = {
  accessToken?: string;
  refreshToken?: string;
  AppStorage: ToDo;
};

type ClearTokensProps = {
  AppStorage: ToDo;
};

global.atob = decode;

export const saveTokens = ({ accessToken, refreshToken, AppStorage }: SaveTokensProps) => {
  if (!accessToken) return;
  AppStorage().set("token", accessToken);
  try {
    const { exp } = jwtDecode(accessToken) || {};

    if (refreshToken) AppStorage().set("refreshToken", refreshToken);
    if (exp) {
      AppStorage().set("tokenExpiresIn", `${exp * 1000}`);
      AppStorage().set("refreshExpiresIn", `${exp * 1000}`);
    }
  } catch {}
};

export const clearTokens = ({ AppStorage }: ClearTokensProps) => {
  AppStorage().delete("token");
  AppStorage().delete("tokenExpiresIn");
  AppStorage().delete("refreshToken");
  AppStorage().delete("refreshExpiresIn");
  AppStorage().delete("deviceFingerprint");
};

let pushToken: string | null = null;

export const getPushNotificationToken = async () => {
  if (pushToken || isWeb) return pushToken;

  try {
    const projectId =
      Constants?.expoConfig?.extra?.eas?.projectId ?? Constants?.easConfig?.projectId;
    if (!projectId) {
      throw new Error("Project ID not found");
    }
    const { data } = await Notifications.getExpoPushTokenAsync({ projectId });

    pushToken = data;
  } catch {}

  return pushToken;
};
